import axios from "axios";
import { store } from "../store";
import { refreshToken } from "../features";
import { jwtDecode } from "jwt-decode";

export const axiosPublic = axios.create({
  baseURL: "http://localhost:5000/api",
});
export const axiosPrivate = axios.create({
  baseURL: "http://localhost:5000/api",
});

export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#f2faf8', // for option hover bg-color
    primary: '#4b5563', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#66b5a3',//'#ededed', // for input border-color
    neutral30: '#f2faf8',//'#ededed' // for input hover border-color
    neutral50: '#4b5563',//'#ededed' // for input placeholder color
    neutral80: "#66b5a3"//'#ededed' // for input color
  }
})

axiosPrivate.interceptors.request.use(
  async (config) => {
    const user = store?.getState()?.userData?.user;

    let currentDate = new Date();
    if (user?.token) {
      config.headers["authorization"] = `Bearer ${store?.getState()?.userData?.user?.token}`;

      // const decodedToken = jwtDecode(user?.token);
      // if (decodedToken.exp * 1000 < currentDate.getTime()) {
      //   await store.dispatch(refreshToken());
      //   if (config?.headers) {
      //     config.headers["authorization"] = `Bearer ${store?.getState()?.userData?.user?.token}`;
      //   }
      // }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
